// Module-level handle to the global search input so the "/" keyboard shortcut can focus it
// from the app-level key handler without prop-drilling a ref through the layout.

let el: HTMLInputElement | null = null;

export function setSearchEl(node: HTMLInputElement | null): void {
  el = node;
}

export function focusSearch(): void {
  el?.focus();
}
